/**
 * Pop stack back to Profile tab (Referral, Addresses, etc.).
 * Uses reset so native & web behave the same (Alert.onPress alone often fails on web).
 */
import { CommonActions } from '@react-navigation/native';

const MAIN_TAB_ROUTES = [
  { name: 'Home' },
  { name: 'Coupons' },
  { name: 'TukarPoin' },
  { name: 'Estamps' },
  { name: 'Profile' },
];
const PROFILE_TAB_INDEX = 4;

export function goToProfileTab(navigation) {
  if (!navigation?.dispatch) {
    return;
  }
  try {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [
          {
            name: 'MainTabs',
            state: {
              routes: MAIN_TAB_ROUTES,
              index: PROFILE_TAB_INDEX,
            },
          },
        ],
      }),
    );
  } catch (e) {
    console.warn('goToProfileTab reset failed, fallback navigate', e?.message);
    try {
      navigation.navigate('MainTabs', { screen: 'Profile' });
    } catch (e2) {
      console.warn('goToProfileTab navigate failed', e2?.message);
    }
  }
}
